import { GET_MATCHING_DRUGS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Drug {
    id: string;
    name: string;
    manufacturer_name: string;
    product_type: string;
    generic_name?: string;
    dosage?: {
        df_id?: string;
        unit?: string;
        unit_val?: string;
        dosage?: string;
        dosage_form?: string;
        days?: string;
        food?: string;
    };
    soa?: boolean;
}

export default (text?: string): Promise<Drug[]> =>
    fetchWithRefresh(GET_MATCHING_DRUGS(text || '')).then((res) => res.json());
